export default "__VITE_ASSET__a2880f47__"